import React from "react";
import LegalPage from "@/pages/legal/LegalPage";

const Disclaimer = () => (
  <LegalPage testid="page-disclaimer" overline="Legal" title="Disclaimer" lastUpdated="December 2025">
    <h2>Website Disclaimer</h2>
    <p>
      The information provided by The Exit Strategy Society, 4ever Wellness LLC, and Dr.
      Phelesia Foster, PhD is for educational and informational purposes only.
    </p>
    <p>
      ESS does not provide legal, tax, accounting, investment, financial advisory, medical,
      mental health, or therapeutic services.
    </p>
    <p>
      Information related to entrepreneurship, productivity, digital products, financial
      wellness, business development, income generation, and personal development is
      educational in nature and should not be considered professional advice.
    </p>
    <p>
      Visitors should consult qualified professionals regarding their individual circumstances.
      No guarantees are made regarding earnings, funding, business success, financial
      outcomes, productivity improvements, or personal achievements. Individual results vary.
    </p>

    <h2>Earnings Disclaimer</h2>
    <p>ESS makes no guarantees regarding:</p>
    <ul>
      <li>Income</li>
      <li>Revenue</li>
      <li>Business growth</li>
      <li>Grant awards</li>
      <li>Funding approvals</li>
      <li>Loan approvals</li>
      <li>Credit outcomes</li>
      <li>Financial success</li>
    </ul>
    <p>Testimonials and examples are illustrative only.</p>

    <h2>Grant Funding Disclaimer</h2>
    <p>
      ESS may provide educational information regarding grants and funding opportunities. ESS
      does not guarantee grant awards, sponsorships, investments, funding approvals, or
      financial assistance. All funding decisions are made solely by the issuing organizations.
    </p>

    <h2>Affiliate Disclosure</h2>
    <p>
      Some website links may be affiliate links. ESS may receive compensation from qualifying
      purchases at no additional cost to visitors.
    </p>
  </LegalPage>
);

export default Disclaimer;
